export default "__VITE_PUBLIC_ASSET__87e85baa__"